import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Row,
  Col,
  Modal,
  Form,
  Button,
  Tabs,
  Tab,
  Alert as AlertControl,
} from "react-bootstrap";
import ServiceProfile from "./Service/ServiceProfile";
import { ListServiceContext } from "../../../App";
const FormService = (props) => {
  /// State Context
  const { listService, setlistService } = useContext(ListServiceContext);
  ///Props

  const { Edit, rowService, idS } = props;

  //// useState

  const [designation, setdesignation] = useState();
  const [price, setPrice] = useState("");
  const [type, setType] = useState("");
  /// setState
  const SetStateService = () => {
    if (rowService) {
      setdesignation(rowService[0].designation);
      setPrice(rowService[0].price);
      setType(rowService[0].type ? rowService[0].type : "--");
    }
  };
  ///ADD Service
  // const idSer = listService && listService[listService.length - 1].id + 1;
  // const HandleAddService = (e, id = idSer) => {
  const HandleAddService = (e) => {
    ServiceProfile.addService([{ designation, price, type }], {
      id: JSON.parse(sessionStorage.getItem("dataCabinet")).id,
    }).then((res) => {
      window.location.reload();
      // window.location.replace("/profile");
      // setlistService([
      //   {
      //     id,
      //     designation,
      //     price,
      //     type,
      //   },
      //   ...listService,
      // ]);
    });
  };

  // update Service

  const HandleUpdateService = () => {
    ServiceProfile.updateService(idS, designation, price, type).then((res) => {
      window.location.reload();
      // window.location.replace("/profile");
    });
  };

  /// clear State
  const Clear = () => {
    if (Edit == "ADD") {
      setdesignation("");
      setPrice("");
      setType("--");
    }
  };

  useEffect(() => {
    SetStateService();
  }, [idS]);
  useEffect(() => {
    Clear();
  }, [Edit]);

  // check labo or midecin

  const profSante = JSON.parse(sessionStorage.getItem("profSante")).speciality;

  return (
    <>
      <Container>
        {Edit == "Edit" ? (
          <Row>
            <Col lg={12}>
              <Row>
                <Col lg={5} className="mt-3">
                  <Form.Control
                    className="mb-2"
                    name="designation"
                    type="text"
                    placeholder="Service"
                    onChange={(e) => {
                      setdesignation(e.target.value);
                    }}
                    defaultValue={designation}
                  />
                </Col>
                <Col lg={2} className="mt-3">
                  <Form.Control
                    className="mb-2"
                    name="price"
                    type="text"
                    placeholder="prix"
                    onChange={(e) => {
                      setPrice(e.target.value);
                    }}
                    defaultValue={price}
                  />
                </Col>
                {!profSante && (
                  <Col lg={3} className="mt-3">
                    <Form.Group controlId="calendar.SelectCustom">
                      <Form.Control
                        as="select"
                        name="type"
                        custom
                        onChange={(e) => {
                          setType(e.target.value);
                        }}
                        value={type}
                      >
                        <option>--</option>
                        <option>Non Covid</option>
                        <option>Covid</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                )}
                <Col lg={2}>
                  <Button
                    style={{ height: "40px", marginTop: "13px" }}
                    className="btn2 home"
                    variant="success"
                    onClick={() => HandleUpdateService()}
                  >
                    Modifier
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col lg={12}>
              <Row>
                <Col lg={5} className="mt-3">
                  <Form.Control
                    className="mb-2"
                    type="text"
                    placeholder="Service"
                    defaultValue={designation}
                    onChange={(e) => {
                      setdesignation(e.target.value);
                    }}
                  />
                </Col>
                <Col lg={2} className="mt-3">
                  <Form.Control
                    className="mb-2"
                    type="text"
                    placeholder="prix"
                    onChange={(e) => {
                      setPrice(e.target.value);
                    }}
                    defaultValue={price}
                  />
                </Col>
                {!profSante && (
                  <Col lg={3} className="mt-3">
                    <Form.Group controlId="calendar.SelectCustom">
                      <Form.Control
                        as="select"
                        custom
                        onChange={(e) => {
                          setType(e.target.value);
                        }}
                        value={type}
                      >
                        <option>--</option>
                        <option>Non Covid</option>
                        <option>Covid</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                )}
                <Col lg={2}>
                  <Button
                    style={{ height: "40px", marginTop: "13px" }}
                    className="btn2 home"
                    variant="primary"
                    onClick={() => HandleAddService()}
                  >
                    Ajouter
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </Container>
    </>
  );
};

export default FormService;
